import { apiUc, apiInstagramChat as apiChatTs } from '../../../../../http';
class QueueChatPauseService {
  constructor() {}
  pauseOn(pauseId) {
    return apiChatTs.post(
      `/agent-status-chat/pause-queue-chat/${localStorage.getItem(
        'login'
      )}/${pauseId}`
    );
  }

  pauseOff() {
    return apiChatTs.post(
      `/agent-status-chat/unpause-queue-chat/${localStorage.getItem('login')}`
    );
  }

  async getAgentStatusChat() {
    const result = await apiChatTs.get(
      `/agent-status-chat/basic-data/${localStorage.getItem('login')}`
    );

    return result.data?.data;
  }

  async getAll() {
    const response = await apiUc.get(`/api/pausas?q=&showDisable=false`);
    return response.data;
  }

  async loginInNewQueues(data) {
    const response = await apiChatTs.post(
      `/agent-status-chat/login-in-new-queues-chat/${localStorage.getItem(
        'login'
      )}`,
      {
        queuesToLogin: data
      }
    );
    return response.data.data;
  }

  async logoutInQueues(data) {
    const response = await apiChatTs.post(
      `/agent-status-chat/logout-in-queues-chat/${localStorage.getItem(
        'login'
      )}`,
      {
        queuesToLogout: data
      }
    );
    return response.data.data;
  }
}

export default new QueueChatPauseService();
